import { gql } from '@apollo/client';

export const NEW_IMAGE = gql`
  fragment NewImage on Image {
    id
  }
`;
